import React from "react";
import PhoneVerificationSignup from "../../../../../Diathrive/src/containers/PhoneVerificationSignup";

const PhoneVerification = (props) => <PhoneVerificationSignup {...props} />;

export default PhoneVerification;
